/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model from '@tripian/model';
import classes from './CategoryList.scss';
import { ChevronUp, ChevronDown } from '../base/Svg/Icons';

interface CategoryListProps {
  categories: Model.PoiCategoryGroup[];
  selectedCategoryIds: number[];
  onChange: (selected: Model.PoiCategory[]) => void;
}

const CategoryList: React.FC<CategoryListProps> = ({ categories, selectedCategoryIds, onChange }) => {
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);

  const toggleGroup = (groupName: string) => {
    setExpandedGroups((prev) => (prev.includes(groupName) ? prev.filter((name) => name !== groupName) : [...prev, groupName]));
  };

  const handleCategoryChange = (categoryId: number) => {
    const allCategories = categories.flatMap((group: Model.PoiCategoryGroup) => group.categories);
    const category = allCategories.find((cat: Model.PoiCategory) => cat.id === categoryId);

    if (category) {
      const newSelected = selectedCategoryIds.includes(categoryId) ? allCategories.filter((cat) => selectedCategoryIds.includes(cat.id) && cat.id !== categoryId) : [...allCategories.filter((cat) => selectedCategoryIds.includes(cat.id)), category];

      onChange(newSelected);
    }
  };

  const handleGroupChange = (group: Model.PoiCategoryGroup) => {
    const groupCategoryIds = group.categories.map((cat) => cat.id);
    const allGroupSelected = groupCategoryIds.every((id) => selectedCategoryIds.includes(id));

    const allCategories = categories.flatMap((g: Model.PoiCategoryGroup) => g.categories);
    if (allGroupSelected) {
      onChange(allCategories.filter((cat) => !groupCategoryIds.includes(cat.id) && selectedCategoryIds.includes(cat.id)));
    } else {
      const currentSelected = allCategories.filter((cat) => selectedCategoryIds.includes(cat.id));
      const newCategories = group.categories.filter((cat) => !selectedCategoryIds.includes(cat.id));
      onChange([...currentSelected, ...newCategories]);
    }
  };

  const handleSelectAll = () => {
    const allCategories = categories.flatMap((group: Model.PoiCategoryGroup) => group.categories);
    const allSelected = allCategories.length === selectedCategoryIds.length;

    onChange(allSelected ? [] : allCategories);
  };

  return (
    <div className={classes.categoryList}>
      <label className={classes.categoryListAll}>
        <input type="checkbox" className={classes.categoryListCheckboxInput} checked={selectedCategoryIds.length === categories.reduce((sum, group) => sum + group.categories.length, 0)} onChange={handleSelectAll} />
        <span className={classes.categoryListCheckboxText}>All</span>
      </label>

      {categories.map((group) => (
        <div key={group.name} className={classes.categoryListGroup}>
          <button type="button" className={classes.categoryListGroupButton} onClick={() => toggleGroup(group.name)}>
            <div className={classes.categoryListCheckboxLabel}>
              <input type="checkbox" className={classes.categoryListCheckboxInput} checked={group.categories.every((cat) => selectedCategoryIds.includes(cat.id))} onChange={() => handleGroupChange(group)} />
              <span className={classes.categoryListCheckboxText}>{group.name}</span>
            </div>
            {expandedGroups.includes(group.name) ? <ChevronUp className={classes.categoryListGroupIcon} /> : <ChevronDown className={classes.categoryListGroupIcon} />}
          </button>

          {expandedGroups.includes(group.name) && (
            <div className={classes.categoryListGroupContent}>
              {group.categories.map((category) => (
                <label key={category.id} className={classes.categoryListCheckboxLabel}>
                  <input type="checkbox" className={classes.categoryListCheckboxInput} checked={selectedCategoryIds.includes(category.id)} onChange={() => handleCategoryChange(category.id)} />
                  <span className={classes.categoryListCheckboxText}>{category.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryList;
